import React from 'react';
import './GrantAssetsPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';

const PAGE_ID = 'GrantAssetsPage';

function GrantAssetsPage({targetUserName, onBack, onGrantChest, onGrantSkin, onGrantCrystals, onGrantPremium}) {
  usePageAnalytics('GrantAssetsPage');

  return (
    <>
      <h1 className="lobby-page-title grant-assets-page-title">
        Начислить имущество
        {targetUserName && <span className="grant-assets-page-subtitle">{targetUserName}</span>}
      </h1>

      <div className="grant-assets-buttons">
        <PageButton
          className="grant-assets-button"
          onClick={onGrantChest}
          pageId={PAGE_ID}
          buttonId="grant_chest"
        >
          Начислить сундук
        </PageButton>
        <PageButton
          className="grant-assets-button"
          onClick={onGrantSkin}
          pageId={PAGE_ID}
          buttonId="grant_skin"
        >
          Начислить скин фракции
        </PageButton>
        <PageButton
          className="grant-assets-button"
          onClick={onGrantCrystals}
          pageId={PAGE_ID}
          buttonId="grant_crystals"
        >
          Начислить кристаллы
        </PageButton>
        <PageButton
          className="grant-assets-button"
          onClick={onGrantPremium}
          pageId={PAGE_ID}
          buttonId="grant_premium"
        >
          Начислить премиум
        </PageButton>
      </div>

      <div className="main-menu-buttons grant-assets-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GrantAssetsPage;
